// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"471":"locale-en-translation-json","853":"locale-es-translation-json"}[chunkId] || chunkId) + "." + {"56":"0b8b3add","404":"77b9a598","452":"2a701ced","471":"d5538508","513":"6770824a","770":"b1bc8ff7","853":"09b9210f"}[chunkId] + ".chunk.js";
};